"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.setDevices = function (devices) { return toolkit_1.createAction(constants_1.SET_DEVICES)(devices); };
exports.setIsConnected = function (isConnected) { return toolkit_1.createAction(constants_1.SET_IS_CONNECTED)(isConnected); };
exports.setIsConnecting = function (isConnecting) {
    return toolkit_1.createAction(constants_1.SET_IS_CONNECTING)(isConnecting);
};
exports.setIsPlayerExpanded = function (isPlayerExpanded) {
    return toolkit_1.createAction(constants_1.SET_IS_PLAYER_EXPANDED)(isPlayerExpanded);
};
exports.setIsPlayerSeasonsSelectorVisible = function (isPlayerSeasonsSelectorVisible) {
    return toolkit_1.createAction(constants_1.SET_IS_PLAYER_SEASONS_SELECTOR_VISIBLE)(isPlayerSeasonsSelectorVisible);
};
exports.setConnectedDevice = function (device) { return toolkit_1.createAction(constants_1.SET_CONNECTED_DEVICE)(device); };
exports.setCastingIsLoading = function (castingIsLoading) {
    return toolkit_1.createAction(constants_1.SET_CASTING_IS_LOADING)(castingIsLoading);
};
exports.setCastingData = function (castingData) { return toolkit_1.createAction(constants_1.SET_CASTING_DATA)(castingData); };
exports.setConnectingError = function (connectionError) {
    return toolkit_1.createAction(constants_1.CONNECTING_ERROR)(connectionError);
};
exports.setCastingError = function (castingError) { return toolkit_1.createAction(constants_1.CASTING_ERROR)(castingError); };
exports.setIsReadyToCast = function (isAvailable) {
    return toolkit_1.createAction(constants_1.SET_IS_READY_TO_CAST)(isAvailable);
};
exports.setIsAttemptingToCast = function (isAttempting) {
    return toolkit_1.createAction(constants_1.SET_IS_ATTEMPTING_TO_CAST)(isAttempting);
};
exports.setIsDeviceModalOpen = function (isOpen) {
    return toolkit_1.createAction(constants_1.SET_IS_DEVICE_MODAL_OPEN)(isOpen);
};
exports.setVolumeLevel = function (level) { return toolkit_1.createAction(constants_1.SET_VOLUME_LEVEL)(level); };
//# sourceMappingURL=actions.js.map